import * as React from 'react';
import { Component } from 'react';
import { Anchor } from './Anchor';
import { Image } from './Image';
import Menu from './Menu';
import { Navbar, NavbarHeader } from '../bootstrap-components/BootstrapComponents';
import { Icon } from '../Icon';
import { Bruger } from '../../models/Bruger';
import { getSite, isTestSite, isDemoSite } from '../../infrastructure/site/SiteProvider';
import { canImpersonate, getBrugerDisplayName, erElev } from '../../infrastructure/Security';
import { Clearfix } from './Clearfix';
import { isImpersonating } from '../../infrastructure/Security';

export interface NavigationProps {
    bruger?: Bruger;
}

export interface NavigationState {
}

class Navigation extends Component<NavigationProps, NavigationState> {

    getImpersonationNavItem() {
        let ci = canImpersonate();
        if (ci) {
            return (
                <li>
                    <Anchor href='/log-ind-som'>
                        <Icon name='user' />
                        Log ind som
                    </Anchor>
                </li>
            );
        }

        return undefined;
    }    

    getBrugerVilkaar() {
        if (!erElev()) {
            return (
                <li>
                    <Anchor href='/brugervilkaar'><Icon name='document' />Brugervilkår</Anchor>
                </li>
            );
        }

        return undefined;
    }

    render() {
        const showNavbars = this.props.bruger && (this.props.bruger.accepteretVilkaar || isImpersonating() || erElev());
        return (
            <Navbar>
                {showNavbars &&
                    <Menu />
                }

                <NavbarHeader>
                    <Anchor href='/'><Image source={getSite().logoName} alt='logo' /></Anchor>
                </NavbarHeader>
                {isTestSite() &&
                    <div className='test-site'>
                        <h1>Test site!</h1>
                    </div>
                }
                {isDemoSite() &&
                    <div className='test-site'>
                        <h1>Demo site!</h1>
                    </div>
                }
                {showNavbars &&
                    <div id='user-dropdown-wrapper'>
                        <ul className='nav navbar-nav navbar-right'>
                            <li className='dropdown'>
                                <a href='#' id='avatar-toggle' className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>
                                    <Image className='avatar' source='avatar-small.png' />
                                    <p className='avatar-name'>{getBrugerDisplayName()}</p>
                                    <span className='caret' />
                                </a>
                                <ul className='dropdown-menu'>

                                    <li>
                                        <Anchor href='/bruger-profil'>
                                            <Icon name='user' />Profil
                                        </Anchor>
                                    </li>

                                    {this.getBrugerVilkaar()}

                                    <li>
                                        <Anchor href='/Logout'>
                                            <Icon name='lock' />
                                            Log ud
                                        </Anchor>
                                    </li>
                                    {this.getImpersonationNavItem()}

                                </ul>
                            </li>
                        </ul>
                        <Clearfix />

                    </div>
                }

            </Navbar>
        );
    }
}

export default Navigation;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/Navigation.tsx